import { appDependencies } from "../AppDependencies";
import { IRequestTranslation } from "./IRequestTranslation";

export class TranslationService implements IRequestTranslation {
    translate(translationKey: string, obj?: {}): string {
        return appDependencies.ICanTranslate.translate(translationKey, obj);
    }
}
